export default "/images/vendor/flag-icon-css/flags/4x3/mm.svg?6f93c6d0ec04077b61c7c7f0f97f0332";